// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-body{
    border-radius: 60px;
    overflow-y: auto;
    text-align: center;
    height: 100%;
    width: 40px !important;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }

.imgSidebar{
     cursor: pointer;
    width: 60%;
    margin: 25px 5px;
    /* padding-top: 60%;
    padding-bottom: 30%; */
}

.sidebar-body > ::-webkit-scrollbar{
    width: 0;
}

.sidebar-body > div{
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

/*.sidebar-body div img :hover{    
     in case you want to add the hover effect to your images
}*/
/* @media screen and (max-width: 1190px) and (min-width: 1080px){
    .sidebar-body{
        height:80%;
        width: 40% !important;
    }
}
@media screen and (max-width: 1079px) and (min-width: 1040px){
    .sidebar-body{
        height:88%;
        
    }
}
@media screen and (max-width: 1039px) and (min-width: 950px){
    .sidebar-body{
        height:83%;
        
    }
}
@media screen and (max-width: 949px) and (min-width: 840px){
    .sidebar-body{
        height:85%;
       
    }
}
@media screen and (max-width: 839px) and (min-width: 715px){
    .sidebar-body{
        height:85%;
        
    }
}
@media screen and (max-width: 714px) and (min-width: 650px){
    .sidebar-body{
        height:77%;
        
    }
}
@media screen and (max-width: 749px) and (min-width: 600px){
    .sidebar-body{
        height:70%;
        
    }
}
@media screen and (max-width: 599px) and (min-width: 560px){
    .sidebar-body{
        height:75%;
        width: 46% !important;
        
    }
}
@media screen and (max-width: 559px){
    .sidebar-body{
        height:68%;
        width: 46% !important;
        
    }
}



 */
`, "",{"version":3,"sources":["webpack://./src/components/SideBar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;AAEF;KACK,eAAe;IAChB,UAAU;IACV,gBAAgB;IAChB;0BACsB;AAC1B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;EAEE;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2DE","sourcesContent":[".sidebar-body{\n    border-radius: 60px;\n    overflow-y: auto;\n    text-align: center;\n    height: 100%;\n    width: 40px !important;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n.imgSidebar{\n     cursor: pointer;\n    width: 60%;\n    margin: 25px 5px;\n    /* padding-top: 60%;\n    padding-bottom: 30%; */\n}\n\n.sidebar-body > ::-webkit-scrollbar{\n    width: 0;\n}\n\n.sidebar-body > div{\n    height: 100%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n/*.sidebar-body div img :hover{    \n     in case you want to add the hover effect to your images\n}*/\n/* @media screen and (max-width: 1190px) and (min-width: 1080px){\n    .sidebar-body{\n        height:80%;\n        width: 40% !important;\n    }\n}\n@media screen and (max-width: 1079px) and (min-width: 1040px){\n    .sidebar-body{\n        height:88%;\n        \n    }\n}\n@media screen and (max-width: 1039px) and (min-width: 950px){\n    .sidebar-body{\n        height:83%;\n        \n    }\n}\n@media screen and (max-width: 949px) and (min-width: 840px){\n    .sidebar-body{\n        height:85%;\n       \n    }\n}\n@media screen and (max-width: 839px) and (min-width: 715px){\n    .sidebar-body{\n        height:85%;\n        \n    }\n}\n@media screen and (max-width: 714px) and (min-width: 650px){\n    .sidebar-body{\n        height:77%;\n        \n    }\n}\n@media screen and (max-width: 749px) and (min-width: 600px){\n    .sidebar-body{\n        height:70%;\n        \n    }\n}\n@media screen and (max-width: 599px) and (min-width: 560px){\n    .sidebar-body{\n        height:75%;\n        width: 46% !important;\n        \n    }\n}\n@media screen and (max-width: 559px){\n    .sidebar-body{\n        height:68%;\n        width: 46% !important;\n        \n    }\n}\n\n\n\n */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
